import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g>
    <path
      d="M8.46272469,12.8469209 C6.96976949,11.7555049 6,9.99100335 6,8 C6,4.6862915 8.6862915,2 12,2 C15.3137085,2 18,4.6862915 18,8 C18,9.99100335 17.0302305,11.7555049 15.5372753,12.8469209 C18.0550413,13.3791601 20.1265817,14.5250263 21.7337334,16.2928932 C21.9112445,16.4881554 22,16.7440777 22,17 L22,21 C22,21.5522847 21.5929861,22 21.0909091,22 L2.90909091,22 C2.40701386,22 2,21.5522847 2,21 L2,17 C2,16.7440777 2.08875552,16.4881554 2.26626656,16.2928932 C3.87341834,14.5250263 5.9449587,13.3791601 8.46272469,12.8469209 Z M20.1818182,17.4263429 C18.2585354,15.4826327 15.546847,14.5 12,14.5 C8.453153,14.5 5.74146463,15.4826327 3.81818182,17.4263429 L3.81818182,20 L20.1818182,20 L20.1818182,17.4263429 L20.1818182,17.4263429 Z M12,12 C14.209139,12 16,10.209139 16,8 C16,5.790861 14.209139,4 12,4 C9.790861,4 8,5.790861 8,8 C8,10.209139 9.790861,12 12,12 Z"
      fill={fill}
    />
  </g>
);

export default Icon;
